import get from 'lodash/get';

function beforeRequest(actionContext, { options = {} }) {
	actionContext.dispatch('RETRIEVE_EXPORT_CONFIG_START', options);
}

function onSuccess(actionContext, callContext) {
	const {
		response: { data },
	} = callContext;

	actionContext.dispatch('RETRIEVE_EXPORT_CONFIG_SUCCESS', data);
}

function onFailed(actionContext, callContext) {
	const { error } = callContext;

	actionContext.dispatch('RETRIEVE_EXPORT_CONFIG_FAILED', error);
}

export default config => ({
	serviceName: 'retrieveExportConfig',
	authenticate: true,
	config: {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		url: get(config, 'endpoints.prompt.configuration.export.retrieve'),
	},
	beforeRequest,
	onSuccess,
	onFailed,
	onError: onFailed,
	onTimeout: onFailed,
	onFatal: onFailed,
});
